/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Atelier_SentInputs */

const en_scene_atelier_sent = /** @type {(inputs: Scene_Atelier_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to Tomorrow`)
};

/**
* | output |
* | --- |
* | "Sent to Tomorrow" |
*
* @param {Scene_Atelier_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_atelier_sent = /** @type {((inputs?: Scene_Atelier_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Atelier_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_atelier_sent(inputs)
});